interface SEOProps {
  title: string;
  description: string;
  keywords: string;
  canonicalUrl?: string;
  ogType?: string;
  ogImage?: string;
  articlePublishedTime?: string;
  articleModifiedTime?: string;
  schemaJson?: Record<string, unknown>[];
}

export default function SEO({
  title,
  description,
  keywords,
  canonicalUrl = 'https://aitdev.cn',
  ogType = 'website',
  ogImage = 'https://readdy.ai/api/search-image?query=A%20warm%20minimalist%20parenting%20guide%20illustration%2C%20soft%20cream%20and%20beige%20tones%2C%20gentle%20abstract%20shapes%2C%20clean%20editorial%20style&width=1200&height=630&seq=og-default-2026&orientation=landscape',
  articlePublishedTime,
  articleModifiedTime,
  schemaJson = [],
}: SEOProps) {
  const baseSchemas: Record<string, unknown>[] = [
    {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      name: '明智育儿指南',
      url: 'https://aitdev.cn',
      description: '围绕传统管教方式，深度解析心理学依据、适用争议、替代方案及专家建议，帮助家长科学理解打屁股对儿童身心发展的影响。',
      email: 'contact@wise-parenting-guide.cn',
      telephone: '400-888-6789',
      address: {
        '@type': 'PostalAddress',
        streetAddress: '建国路88号SOHO现代城A座1508室',
        addressLocality: '北京',
        addressRegion: '朝阳区',
        addressCountry: 'CN',
      },
    },
    {
      '@context': 'https://schema.org',
      '@type': 'WebSite',
      name: '明智育儿指南',
      url: 'https://aitdev.cn',
      description: description,
      inLanguage: 'zh-CN',
    },
    {
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      name: title,
      description: description,
      url: canonicalUrl,
      inLanguage: 'zh-CN',
    },
  ];

  const allSchemas = [...baseSchemas, ...schemaJson];

  return (
    <>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={canonicalUrl} />

      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:type" content={ogType} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:site_name" content="明智育儿指南" />
      <meta property="og:locale" content="zh_CN" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />

      <meta name="geo.position" content="39.9087;116.4713" />
      <meta name="geo.region" content="CN-11" />
      <meta name="geo.placename" content="北京市朝阳区" />

      {articlePublishedTime && (
        <meta property="article:published_time" content={articlePublishedTime} />
      )}
      {articleModifiedTime && (
        <meta property="article:modified_time" content={articleModifiedTime} />
      )}

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(allSchemas) }}
      />
    </>
  );
}